module.exports = __webpack_public_path__ + "components/country-flag/static/lc-ef2f21a9501810a6d37201d4c3dc1115.svg";